import { useState, useEffect } from "react";
import { valueToPercentage } from "./Slider.operations";
const useSliderGradient = ({
  min,
  max,
  values,
  dualRange,
  activeColor,
  backgroundColor
}) => {
  const [gradient, setGradient] = useState({});
  const firstHandlePercent = valueToPercentage(min, max, values[0]);
  const secondHandlePercent = valueToPercentage(min, max, values[0], values[1], true);
  const generateGradient = () => {
    return {
      background: `linear-gradient(${dualRange ? `
        90deg,
        ${backgroundColor} 0%,
        ${backgroundColor} ${firstHandlePercent}%,
        ${activeColor} ${firstHandlePercent}%,
        ${activeColor} ${secondHandlePercent}%,
        ${backgroundColor} ${secondHandlePercent}%,
        ${backgroundColor} 100%
      ` : `
        90deg,
        ${activeColor} 0%,
        ${activeColor} ${firstHandlePercent}%,
        ${backgroundColor} ${firstHandlePercent}%,
        ${backgroundColor} 100%
      `})`
    };
  };
  useEffect(() => {
    setGradient(generateGradient());
  }, [values, min, max]);
  return gradient;
};
export default useSliderGradient;
